import React, { useEffect, useRef, useState } from "react";
import "./styles.css";
import { setTitle } from "./utils";
import { submitContactForm } from "./APICall";

export default function Home() {

  const contactRef = useRef(null);

  useEffect(() => {
    setTitle("Acacia Electric LLC");
  }, []);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [formErrors, setFormErrors] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setFormErrors({ ...formErrors, [name]: "" });
  };

  const validateForm = () => {
    let valid = true;
    const errors = {};

    if (!formData.name.trim()) {
      errors.name = "Name is required";
      valid = false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email.trim() || !emailRegex.test(formData.email)) {
      errors.email = "Valid email is required";
      valid = false;
    }

    const phoneRegex = /^\D?(\d{3})\D?\D?(\d{3})\D?(\d{4})$/;
    if (!formData.phone.trim() || !phoneRegex.test(formData.phone)) {
      errors.phone = "Valid phone number is required";
      valid = false;
    }

    if (!formData.message.trim()) {
      errors.message = "Message is required";
      valid = false;
    }

    setFormErrors(errors);
    return valid;
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      await submitContactForm(formData);
      setIsSubmitted(true);
    } catch (err) {
      console.error("Contact form submission failed", err);
    }
  };

  return (
    <div className="page">
      {/* HERO */}
      <section className="hero">
        <img src="/images/otherlogo.png" alt="Company Logo"/>
        <h1>Reliable Residential & Commercial Electrical Work</h1>
        <p>Licensed. Insured. Local. Quality electrical work you can trust.</p>
        <button className="primary-btn"
          onClick={() =>
            contactRef.current?.scrollIntoView({ behavior: "smooth" })
          }>Request a Quote</button>
      </section>

      {/* SERVICES */}
      <section className="services">
        <h2>Services</h2>
        <div className="service-grid">
          {["Residential Wiring", "Commercial Electrical", "Panel Upgrades", "Lighting Installations", "EV Chargers", "Troubleshooting & Repairs"].map(
            (service) => (
              <div className="service-card" key={service}>
                 <span className="service-title">{service}</span>
                <img src={`/images/${service
                                    .toLowerCase()
                                    .replace(/[^a-z0-9]/g, "")}.jpg`}
                  alt={service}
                  className="service-image"
                  />
                </div>
            )
          )}
        </div>
      </section>

      {/* WHY */}
      <section className="why">
        <h2>Why Choose Us</h2>
        <p>
          Honest pricing, clean work, and clear communication. We show up on time and get the job done right.
        </p>
      </section>

      {/* CONTACT */}
      <section className="contact" ref={contactRef}>
        {isSubmitted ? (
          <div className="thank-you-message">
            <h2>Thank You for Submitting!</h2>
            <p>We will get back to you soon.</p>
          </div>
        ) : (
          <form onSubmit={handleFormSubmit} className="contact-form">
            <h2>Contact</h2>

            <input name="name" placeholder="Name" value={formData.name} onChange={handleInputChange} />
            <div className="error">{formErrors.name}</div>

            <input name="email" placeholder="Email" value={formData.email} onChange={handleInputChange} />
            <div className="error">{formErrors.email}</div>

            <input name="phone" placeholder="Phone" value={formData.phone} onChange={handleInputChange} />
            <div className="error">{formErrors.phone}</div>

            <textarea name="message" rows="4" placeholder="Message" value={formData.message} onChange={handleInputChange} />
            <div className="error">{formErrors.message}</div>

            <button type="submit" className="primary-btn">Send Message</button>
          </form>
        )}

        <div className="contact-info">
        </div>
      </section>

      {/* CONNECT */}
      <section className="connect">
        <h2>Get in Touch</h2>

          <div className="connect-links">
              <a href="tel:12062297007" className="connect-item">
                  📞 (206) 229-7007
              </a>

          <a
            href="https://www.instagram.com/acaciaelectric"
            target="_blank"
            rel="noopener noreferrer"
            className="connect-item"
           >
             📸 Follow us on Instagram
          </a>
        </div>
      </section>
    </div>
  );
}
